import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import MessageClientLink
  from 'Components/Modals/IdentityVerificationReviewDetails/reviewDetailsContent/footer/MessageClientLink';
import { advisorPageMessages } from 'Consts/Strings';
import { buildPageLink } from 'Views/Page/Content/Templates';
import { FDPrimaryActionButton, FDSecondaryActionButton } from '@facet-wealth/design';

const styles = (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  buttonsContainer: {
    display: 'flex',
    columnGap: theme.spacing(2),
  },

});

const FooterButtons = ({
  className,
  classes,
  onDecisionMade,
  onReopen,
  resource,
}) => {
  const onApproveClick = () => {
    const url = resource.relationship(fr.relationships.approveReview.name).link('related').url();
    onDecisionMade(url);
  };

  const onRejectClick = async () => {
    const url = resource.relationship(fr.relationships.rejectReview.name).link('related').url();
    onDecisionMade(url);
  };

  const onReopenClick = async () => {
    const url = resource.relationship(fr.relationships.reopenReview.name).link('related').url();
    onReopen(url);
  };

  const useReopenButton = resource.relationship(fr.relationships.reopenReview.name);
  const useDecisionButtons = resource.relationship(fr.relationships.approveReview.name);

  const messagesPageLink = resource.withRelationship(fr.relationships.messagesPage.name,
    () => buildPageLink(resource.relationship(fr.relationships.messagesPage.name).link('related'), advisorPageMessages),
    () => '/');

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <MessageClientLink messagesPageLink={messagesPageLink} />
      <div className={classes.buttonsContainer}>
        {useReopenButton && (
          <FDPrimaryActionButton
            onClick={onReopenClick}
            label={'Reopen'}
            size={'lg'}
          />
        )}
        {useDecisionButtons && (
          <>
            <FDSecondaryActionButton
              onClick={onRejectClick}
              label={'Reject'}
              size={'lg'}
            />
            <FDPrimaryActionButton
              onClick={onApproveClick}
              label={'Approve'}
              size={'lg'}
            />
          </>
        )}
      </div>
    </Box>
  );
};

FooterButtons.defaultProps = {
  className: '',
};

FooterButtons.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  onDecisionMade: PropTypes.func.isRequired,
  onReopen: PropTypes.func.isRequired,
};

export default withStyles(styles)(FooterButtons);
